/* eslint-disable */

import React from "react";
import { useState } from "react";
import OrganisationActivityElement from "../../../ui-components/organisation-activity-element/organisation-activity-element.tsx";
import MembershipCard from "../../../ui-components/membership-card/membership-card";

import RaindropCopyrightDeclaration from "../../../ui-components/raindrop-copyright-declaration/raindrop-copyright-declaration";
import RaindropAdvertisment from "../../../ui-components/raindrop-advertisement/raindrop-advertisement.tsx";
import RaindropTitle from "../../../ui-components/raindrop-title/raindrop-title.tsx";

import RaindropSlider from "../../../ui-components/raindrop-slider/raindrop-slider.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import Image from "../../../ui-components/image/Image.tsx";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider";
import Currency from "../../../ui-components/currency/currency.tsx";
import {
  EXAMPLE_ORGANISATION_ALPHA_ACTIVITY_TEXT,
  EXAMPLE_ORGANISATION_ALPHA_NAME,
  EXAMPLE_ORGANISATION_ALPHA_URL,
  EXAMPLE_ORGANISATION_BETA_ACTIVITY_TEXT,
  EXAMPLE_ORGANISATION_BETA_NAME,
  EXAMPLE_ORGANISATION_BETA_URL,
  URL_RAINDROP,
} from "../../../services/constants";
import { Link } from "react-router-dom";

import WaterfallActivity from "../../../ui-components/waterfall-activity/waterfall-activity.tsx";
import { Chart } from "react-google-charts";
import OrganisationLogo from "../../../ui-components/organisation-logo/organisation-logo.js";
import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";
import SocialLinkInstagram from "../../../ui-components/social-link-instagram/social-link-instagram.tsx";
import { Color, Size } from "../../../logic/enums.ts";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextHeading2 from "../../../ui-components/raindrop-text-heading-2/raindrop-text-heading-2.tsx";
import FlexRow from "../../../ui-components/flex-row/flex-row.tsx";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropTextCallout from "../../../ui-components/raindrop-text-callout/raindrop-text-callout.tsx";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";

type TitleAndTextProps = {
  title: string;
  text: string;
  text2?: string;
  isCentered?: boolean;
  isFluid?: boolean;
};

const TitleAndText: React.FunctionComponent<TitleAndTextProps> = ({
  title,
  text,
  text2 = "",
  isCentered = false,
  isFluid = false,
}) => {
  let alignment = "text-left";
  let maxWidth = "max-w-lg";
  if (isCentered) {
    alignment = "text-center";
  }

  if (isFluid) {
    maxWidth = "";
  }
  return (
    <div className={`flex flex-col w-full p-4 gap-6 ${maxWidth} ${alignment}`}>
      <RaindropTextCallout text={title} />
      <RaindropTextParagraph>{text}</RaindropTextParagraph>
      <RaindropTextParagraph>{text2}</RaindropTextParagraph>
    </div>
  );
};

const ContentDemoVideo = () => {
  return (
    <div className="flex flex-col w-full max-w-full items-center">
      <iframe
        className="flex w-full aspect-video max-w-3xl"
        // width="560"
        // height="315"
        src="https://www.youtube.com/embed/3s4tuavXOtY?si=QsP2l-oWs0xTWXza"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
    </div>
  );
};

const AnimatedRaindropCircle = () => {
  return (
    <RaindropCircle
      isPulsing={true}
      color={Color.Blue}
      sausageValues={[
        {
          organisationId: "sausage_5FE115AC-D833-49CA-94FF-3D0FB98A7FFD",
          value: 50,
          oldValue: 50,
          selected: false,
        },
        {
          organisationId: "sausage_B87510D1-4E07-4062-A73D-F1C32833AA5D",
          value: 30,
          oldValue: 30,
          selected: false,
        },
        {
          organisationId: "sausage_B87510D1-4E07-4062-A73D-F1C32833AA5D",
          value: 20,
          oldValue: 20,
          selected: false,
        },
      ]}
    />
  );
};

const ContentHero = () => {
  return (
    <FlexCol
      className="w-full justify-center items-center md:flex-row "
      tailwindGap="gap-12"
    >
      <AnimatedRaindropCircle />

      <FlexCol className="w-full max-w-sm" tailwindGap="gap-8">
        <RaindropTextHeading2>
          The free social media for doing good things!
        </RaindropTextHeading2>

        <FlexCol className="w-full max-w-xs">
          <RaindropButton
            title={"Sign up"}
            style={ButtonStyle.Primary}
            size={Size.Large}
            to={`${URL_RAINDROP}/raindrop/sign-up`}
            isFluid={true}
          />
          <RaindropButton
            title={"I already have an account"}
            style={ButtonStyle.Secondary}
            size={Size.Large}
            to={`${URL_RAINDROP}/raindrop/login`}
            isFluid={true}
          />
        </FlexCol>
      </FlexCol>
    </FlexCol>
  );
};

const ContentMission = () => {
  const [stateIdx, setStateIdx] = useState(0);

  const items = [
    "The Earth",
    "People",
    "Justice",
    "Cancer Research",
    "Children",
    "Animals",
    "Mental Health",
    "The Homeless",
    "The Elderly",
    "The Oceans",
    "Rainforests",
    "Equality",
    "Education",
    "The Arts",
    "The Hungry",
  ];

  setTimeout(() => {
    if (stateIdx === items.length - 1) {
      setStateIdx(0);
    } else {
      setStateIdx(stateIdx + 1);
    }
  }, 1200);

  return (
    <div className="flex flex-col items-center justify-center py-16 gap-4 h-full">
      <div className="font-black  text-color-raindrop-primary text-lg">
        OUR MISSION
      </div>
      <div className="font-bold text-5xl text-center max-w-2xl">
        make it fun to do good
      </div>
      <div className="text-color-dark-text-tertiary max-w-lg text-center text-xl">
        When an earthquake strikes, it should take less than five seconds to
        help. No forms, no typing in your card details again, no lock-in, no
        emails you can't control.
      </div>
    </div>
  );
};

const ContentProtect = () => {
  const [stateIdx, setStateIdx] = useState(0);

  const items = [
    "The Earth",
    "People",
    "Justice",
    "Cancer Research",
    "Children",
    "Animals",
    "Mental Health",
    "The Homeless",
    "The Elderly",
    "The Oceans",
    "Rainforests",
    "Equality",
    "Education",
    "The Arts",
    "The Hungry",
  ];

  setTimeout(() => {
    if (stateIdx === items.length - 1) {
      setStateIdx(0);
    } else {
      setStateIdx(stateIdx + 1);
    }
  }, 1200);

  return (
    <div className="hidden md:flex flex-row items-center justify-center py-32 gap-4 h-full bg-color-raindrop-primary rounded-lg">
      <div className="flex items-center justify-end text-end w-full h-20 text-6xl font-black text-color-dark-raindrop-secondary">
        Protect
      </div>
      <div className="flex flex-col h-20 w-full relative justify-center">
        {items.map((item, idx) => {
          let opacity = "opacity-0";
          let translateY = "-translate-y-10";
          let scale = "scale-90";

          if (
            idx === stateIdx - 1 ||
            (stateIdx === 0 && idx === items.length - 1)
          ) {
            translateY = "translate-y-12";
            opacity = "opacity-20";
          }

          if (idx === stateIdx) {
            opacity = "opacity-100";
            translateY = "translate-y-0";
            scale = "scale-100";
          }

          if (
            idx === stateIdx + 1 ||
            (stateIdx === items.length - 1 && idx === 0)
          ) {
            translateY = "-translate-y-12";
            opacity = "opacity-20";
          }

          return (
            <div
              key={idx}
              className={`text-5xl whitespace-nowrap font-bold absolute transition-all ${opacity} ${translateY} ${scale} text-white`}
            >
              {item}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const ContentPhone = () => {
  return (
    <div className="flex flex-col-reverse md:flex-row gap-6   items-center">
      <div className="flex flex-col justify-center items-center md:w-[50%] max-w-sm">
        <img
          id="RD-2221"
          alt="Raindrop App Home Page"
          src="https://production-raindrop-s3-public.s3.eu-west-2.amazonaws.com/2025-03-02_stratus_phone.PNG"
          className="w-64 rounded-3xl border border-white  aspect-auto ima"
        />
      </div>

      <div className="flex flex-col gap-6 w-full items-center max-w-md">
        <TitleAndText
          title={"trustworthy. easy. donations."}
          text={`Here's how it works - you choose how much you'd like to give per month then you distribute where you'd like your contributions to go.`}
        />
      </div>
    </div>
  );
};

const ContentSimplicity = () => {
  const initialValue = 60;
  const [value, setValue] = useState(initialValue);

  const values = [
    {
      organisationId: "sausage_5FE115AC-D833-49CA-94FF-3D0FB98A7FFD",
      value: 100 - value,
      oldValue: 100 - value,
      selected: false,
    },
    {
      organisationId: "sausage_B87510D1-4E07-4062-A73D-F1C32833AA5D",
      value: value,
      oldValue: value,
      selected: true,
    },
  ];

  return (
    <div className="flex flex-col md:flex-row items-center gap-12 w-full max-w-4xl">
      <TitleAndText
        title={"it's just simple"}
        // text={`You can change your distribution at anytime - even pause your
        // contributions entirely. No lock-in, no hidden fees, no awkward phone
        // calls, no clip-boards, no guilt.`}
        text={`You can change your distribution at anytime - even pause your
          contributions entirely. We believe the simpler the process, the more donations to great causes.`}
        text2={`Have a play.`}
      />
      <RaindropCard>
        <div className="flex flex-col w-full max-w-sm p-2 items-center gap-4 ">
          <RaindropCircle
            sausageValues={values}
            isSpringyTransition={false}
            isUsingLayout={false}
            size={"SMALL"}
          />

          <div className="flex flex-col gap-2 w-full  ">
            <div className="flex flex-row gap-2  items-center ">
              <OrganisationLogo src={EXAMPLE_ORGANISATION_ALPHA_URL} />
              <div className="">{EXAMPLE_ORGANISATION_ALPHA_NAME}</div>
              <div className="ml-auto font-bold text-lg text-color-raindrop-primary text-opacity-60">
                <Currency
                  currency={"GBP"}
                  subunits={1000 * (values[0].value / 100)}
                  isStylised={true}
                />
              </div>
            </div>

            <div className="flex flex-row gap-2 items-center  ">
              <OrganisationLogo src={EXAMPLE_ORGANISATION_BETA_URL} />
              <div className="">Greenpeace</div>
              <div className="ml-auto font-bold text-lg text-color-raindrop-primary ">
                <Currency
                  currency={"GBP"}
                  subunits={1000 * (values[1].value / 100)}
                  isStylised={true}
                />
              </div>
            </div>

            <RaindropDivider />

            <div className="flex flex-row gap-2  items-center ">
              <div className="font-bold whitespace-nowrap">
                Your contribution
              </div>
              <div className="ml-auto font-bold text-lg w-fit">
                <Currency currency={"GBP"} subunits={1000} isStylised={true} />
              </div>
            </div>
          </div>

          <div className="w-full">
            <RaindropSlider
              min={10}
              max={90}
              value={value}
              onChange={(newValue) => setValue(newValue)}
            />
          </div>
        </div>
      </RaindropCard>
    </div>
  );
};

const ContentSeeTheDifference = () => {
  return (
    <div className="flex flex-col-reverse md:flex-row   items-center justify-center ">
      <div className="flex flex-col gap-10 w-full p-2 justify-center items-center">
        <OrganisationActivityElement
          organisationName={EXAMPLE_ORGANISATION_ALPHA_NAME}
          subtitle={"12 minutes ago"}
          text={EXAMPLE_ORGANISATION_ALPHA_ACTIVITY_TEXT}
          src={EXAMPLE_ORGANISATION_ALPHA_URL}
          isDisabled={true}
        />

        <OrganisationActivityElement
          organisationName={EXAMPLE_ORGANISATION_BETA_NAME}
          subtitle={"16 minutes ago"}
          text={EXAMPLE_ORGANISATION_BETA_ACTIVITY_TEXT}
          src={EXAMPLE_ORGANISATION_BETA_URL}
          isDisabled={true}
        />
      </div>
      <TitleAndText
        title={"See the difference you make"}
        text={
          "Causes you're supporting will post frequent updates about what they're doing. No more wondering if your contribution is making a difference."
        }
      />
    </div>
  );
};

const ContentShareTheLove = () => {
  return (
    <div className="flex flex-col-reverse md:flex-row w-full items-center justify-center gap-20">
      <div className="flex flex-col w-full relative h-[300px] items-center">
        <div className="bg-color-raindrop-primary  h-[300px] w-[300px] rounded-lg absolute  -rotate-12 -translate-x-4 " />

        <Image
          src="https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/shareable_content__demo_1.png"
          className="h-[300px] z-10 rotate-12 translate-x-4 shadow-2xl shadow-black "
        />
      </div>

      <TitleAndText
        title={"Share the love"}
        text={
          "Share cards are a new way to raise awareness and show your support for causes that matter. They can be shared through messaging apps and social networks like Instagram and TikTok."
        }
        text2={"Share cards are only unlocked after your first contribution."}
      />
    </div>
  );
};

const ContentWaterfall = () => {
  return (
    <div className="flex flex-col md:flex-row w-full justify-center items-center md:gap-12">
      <TitleAndText
        title={"Introducing Waterfalls"}
        text={
          "Take matters into your own hands by creating a personal Waterfall.  Choose the organisation you'd like to support, set a goal, and share your progress with friends and family.  They can add your Waterfall to their Raindrop Circle to support you."
        }
      />
      <div className="flex flex-row w-fit items-center justify-center rotate-3 transition-all">
        <WaterfallActivity
          waterfallTitle={"Rhaz's Waterfall"}
          waterfallDescription={
            "I'm walking 10km every day for the Raindrop Research Trust"
          }
          urlActivity={
            "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/demo-waterfall-activity-6C04F963-DA08-4A44-861C-79DF892BFFE0.jpeg"
          }
          urlOrganisation={EXAMPLE_ORGANISATION_ALPHA_URL}
          urlUser={
            "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/demo-user-profile-picture__BBBC2081-7E50-4BEE-93C1-7C514E43866E.jpeg"
          }
          timeText={"6 days ago"}
          activityDescription={"Still going strong 💪🏼"}
        />
      </div>
    </div>
  );
};

const ContentPricing = () => {
  return (
    <div
      id="content-pricing"
      className="flex flex-col w-full gap-10 items-center  justify-center"
    >
      <div className="flex flex-col gap-6 w-full items-center justify-center">
        <TitleAndText
          isCentered={true}
          title={"All your contribution for good"}
          text={
            "While running a sustainable business we've designed our pricing model to be fair and accomodating.  Choose whichever option is best for you."
          }
          text2={"Either way, you're a gem."}
        />
      </div>

      <div className="flex flex-col items-center">
        <div className="flex flex-col md:flex-row w-full gap-4 p-4 items-center justify-center">
          <MembershipCard isRaindropPlusship={false} />
          <MembershipCard isRaindropPlusship={true} />
        </div>
        <img
          src="https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/arrows__youll-give-the-same-amount.png"
          className="max-w-xs hidden md:block"
        />
      </div>
    </div>
  );
};

const ContentOrganisationPricing = () => {
  let colorGood = "bg-white";
  let colorBad = "bg-color-raindrop-minor";

  return (
    <div className="flex flex-col-reverse md:flex-row gap-8 items-center  ">
      <div className="flex flex-row gap-8 w-full justify-center h-[500px] p-4">
        <div className="flex flex-row gap-4 items-center">
          <img
            src="https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/handdrawn-advertising.png"
            alt=""
            className="w-32 aspect-auto"
          />

          <div
            id="pre-raindrop"
            className="flex flex-col gap-2 items-center w-10 h-full"
          >
            <div
              id="pre-raindrop-good"
              className={`h-[30%] w-10  rounded-full hover:scale-90 transition-all ${colorGood}`}
            ></div>

            <div
              id="pre-raindrop-advertising"
              className={`h-[45%] w-10 rounded-full hover:scale-90 transition-all ${colorBad}`}
            ></div>

            <div
              id="pre-raindrop-base"
              className={`h-[10%] w-10  rounded-full hover:scale-90 transition-all ${colorBad}`}
            ></div>

            <div className="text-color-text-minor">Before</div>
          </div>
        </div>

        <div className="flex flex-row gap-4 items-start justify-start">
          <div
            id="post-raindrop"
            className="flex flex-col h-full gap-2 items-start"
          >
            <div
              id="post-raindrop-good"
              className={`h-[65%] w-10  rounded-full hover:scale-90 transition-all ${colorGood}`}
            ></div>
            <div
              id="post-raindrop-raindrop"
              className="h-[10%] w-10 bg-color-raindrop-primary rounded-full hover:scale-90 transition-all"
            ></div>
            <div
              id="post-raindrop-base"
              className={`h-[10%] w-10 rounded-full hover:scale-90 transition-all ${colorBad}`}
            ></div>
            <div className="text-color-text-minor">After</div>
          </div>
          <img
            alt=""
            src="https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/handdrawn-good-stuff.png"
            className="w-32 aspect-auto"
          />
        </div>
      </div>

      <TitleAndText
        title={"Your money goes further"}
        text={`The Raindrop Company reduces costs by charging a fraction of
        traditional advertising from billboards or having people stand on
        street corners collecting payment`}
        text2={`We provide a platform for organisations to advertise quickly and
        efficiently; with immediately feedback and to an engaged audience.`}
      />
    </div>
  );
};

const ContentTryTheDemo = () => {
  return (
    <div className="flex flex-col gap-12 w-full items-center">
      <TitleAndText
        title={"Request the Demo"}
        text={
          "We've put together a demo so you can see how it works before our app is released.  We'd love to show you, just send us an email telling us who you are and what you're interested in."
        }
        isCentered={true}
      />
      <RaindropButton
        title={"Request the Demo"}
        style={ButtonStyle.Primary}
        size={Size.Large}
        to="mailto:rhaz.solomon@theraindropcompany.com?subject=Raindrop%20Demo%20Request"
      />
    </div>
  );
};

const ContentGetStarted = () => {
  return (
    <div className="flex flex-col gap-12 w-full items-center">
      <TitleAndText
        title={"start donating now"}
        text={"Create your account today!"}
        isCentered={true}
      />
      <div className="flex flex-row gap-4">
        <RaindropButton
          title={"Sign up"}
          style={ButtonStyle.Primary}
          size={Size.Large}
          to={`${URL_RAINDROP}/raindrop/sign-up`}
        />
      </div>
      <p className="text-color-dark-text-secondary font-bold max-w-lg text-center">
        The Raindrop App is still in early-development, so expect some bugs and
        minor issues. We're working hard to make it the best it can be.
      </p>
    </div>
  );
};

const ContentEmployeeBenefits = () => {
  const EmployeeBenefitComponent = ({ title, text }) => {
    return (
      <div className="flex flex-col gap-4  p-4 max-w-sm ">
        <div className="text-4xl font-bold">{title}</div>
        <div className="text-color-raindrop-minor-again">{text}</div>
      </div>
    );
  };

  return (
    <div className="flex flex-col w-full items-center justify-center gap-12">
      <TitleAndText
        title={"We do things differently"}
        text={
          "We're trying to redefine what it means to be a good employer.  We believe doing meaningful good in the world begins with how we treat our staff."
        }
        isCentered={true}
      />

      <div className="flex flex-row gap-4 flex-wrap justify-center">
        <EmployeeBenefitComponent
          title={"Four-day week"}
          text={
            "Employees at The Raindrop Company work Tuesday to Friday.  We believe work shouldn't consume your life."
          }
        />

        <EmployeeBenefitComponent
          title={"Chaos Leave ™"}
          text={
            "At random intervals employees are made to take Chaos Leave™, a forced two-week break from their work, entirely paid."
          }
        />

        <EmployeeBenefitComponent
          title={"Unlimited leave"}
          text={
            "Life happens, it's unpredictable.  We offer an unlimited leave policy to the staff at The Raindrop Company so they can take the time they need."
          }
        />
        <EmployeeBenefitComponent
          title={"Transparent Pay"}
          text={
            "The Raindrop Company publishes all their salary bands because we believe in helping people make informed decisions about their careers."
          }
        />

        <EmployeeBenefitComponent
          title={"Share option scheme"}
          text={
            "Employees at The Raindrop Company are given shares, so the business shares it's successes with the people who helped make it happen."
          }
        />
      </div>
    </div>
  );
};

const ContentQuote = () => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-center gap-12">
      <div className="flex flex-row gap-6 items-center md:max-w-2xl justify-center w-full">
        <div
          id="quote-bar"
          className="flex flex-col items-start h-full justify-start text-left text-color-raindrop-primary text-6xl scale-150 "
        >
          “
        </div>
        <div className="flex flex-col gap-6">
          <div className="text-3xl font-bold text-left">
            If I've learnt anything from my mum, it's to be kind an
            <span className="border-b-2 border-color-raindrop-primary pb-1">
              d love pink
            </span>
          </div>
          <div className="text-color-text-minor text-lg font-semibold">
            Rhaz Solomon, Founder
          </div>
        </div>
      </div>

      <img
        alt="Rhaz and his vibrantly pink mother"
        src="https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/image-pink-mum.jpeg"
        className="w-full max-w-sm rounded-lg"
      />
    </div>
  );
};

const ContentFooter = () => {
  return (
    <div id="content-footer" className="flex flex-col gap-16 w-full p-4">
      <div className="flex flex-col md:flex-row w-full gap-8 md:justify-around">
        <div className="flex flex-col gap-2">
          <div className="font-bold text-color-dark-text-secondary">
            Raindrop
          </div>
          <Link className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary">
            Features
          </Link>
          <Link className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary">
            Pricing
          </Link>
          <Link className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary">
            Working for us
          </Link>
        </div>

        <div className="flex flex-col gap-2 ">
          <div className="font-bold text-color-dark-text-secondary">
            Explore
          </div>
          <Link
            to={"/raindrop"}
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
          >
            Explore Raindrop
          </Link>
          <Link
            to={"/nimbus"}
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
          >
            Explore Nimbus
          </Link>
          <Link
            to={"/stratus"}
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
          >
            Explore Stratus
          </Link>
        </div>

        <div className="flex flex-col gap-2 ">
          <div className="font-bold text-color-dark-text-secondary">
            Support
          </div>
          <Link
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
            to={"mailto:rhaz.solomon@theraindropcompany.com"}
          >
            Contact Us
          </Link>
          <Link
            to={"/stratus/faq"}
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
          >
            Frequently Asked Questions
          </Link>
          <Link
            to={"/stratus/investors"}
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
          >
            For Investors
          </Link>
        </div>

        <div className="flex flex-col gap-2">
          <div className="font-bold text-color-dark-text-secondary">Legal</div>
          <Link
            to={"/stratus/terms-and-conditions"}
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
          >
            Terms and Conditions
          </Link>
          <Link
            to={"/stratus/privacy-policy"}
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
      <RaindropCopyrightDeclaration />
    </div>
  );
};

const ContentFounder = () => {
  return (
    <div className="flex flex-row gap-24 w-full items-center justify-center">
      <div className="flex flex-col gap-3 items-center justify-center w-60 text-center">
        <img
          src="https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/founder-image.jpeg"
          className={"rounded-lg rotate-3"}
        ></img>
        <div className="text-xs text-color-dark-text-tertiary">
          Rhaz Solomon, founder of The Raindrop Company.
        </div>
      </div>

      <div className="flex flex-col gap-6">
        <TitleAndText
          title={"About the Founder"}
          text={"Eccentric and a little bit loopy."}
          text2={
            "I'm Rhaz, a remarkably unremarkable guy. I have however had the privelege of working as a software engineer at some remarkably forward-thinking world-improving pink-themed companies, Sharesies and Octopus Energy."
          }
        />
        <div className="flex flex-row w-full gap-6 items-center justify-center">
          <a href="https://www.sharesies.nz/">
            <img
              src="https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/founder_companies_sharesies.png"
              className="h-16 object-cover"
            />
          </a>
          <a href="https://octopus.energy/">
            <img
              src="https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/founder_companies_octopus.png"
              className="h-16 object-cover rounded-lg"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

const ContentSocialMedia = () => {
  return (
    <div className="flex flex-col-reverse md:flex-row w-full items-center justify-center">
      <div className="flex flex-row gap-4 ">
        <div className="scale-90 rotate-2">
          <WaterfallActivity
            waterfallTitle={"Rhaz's Waterfall"}
            waterfallDescription={
              "I'm walking 10km every day for the Raindrop Research Trust"
            }
            urlActivity={
              "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/demo-waterfall-activity-6C04F963-DA08-4A44-861C-79DF892BFFE0.jpeg"
            }
            urlOrganisation={EXAMPLE_ORGANISATION_ALPHA_URL}
            urlUser={
              "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/demo-user-profile-picture__BBBC2081-7E50-4BEE-93C1-7C514E43866E.jpeg"
            }
            timeText={"6 days ago"}
            activityDescription={"Still going strong 💪🏼"}
          />
        </div>
      </div>
      <TitleAndText
        title={"connect with friends"}
        text={
          "Create Waterfalls to raise money your own way.  Share with your friends and let them support you directly."
        }
      />
    </div>
  );
};

const ContentAdvertisements = () => {
  return (
    <div className="flex flex-col-reverse gap-12 items-center justify-center max-w-3xl p-4">
      <TitleAndText
        title={"Advertisements"}
        text={
          "The Raindrop Company can serve relevant in-app advertisements directly to users wanting to support organisations. We update a user's Raindrop Circle instantly on a single click.  No forwarding to another page, no entering new bank account details."
        }
        isCentered={true}
        isFluid={true}
      />
      <div className="">
        <RaindropAdvertisment />
      </div>
    </div>
  );
};

const ContentSankey = () => {
  const data = [
    ["From", "To", "Weight"],
    ["Users", "Revenue", 20],
    ["Advertisment", "Revenue", 40],
    ["Organisations", "Revenue", 40],
    ["Revenue", "Stripe", 19],
    ["Revenue", "Profit", 20],
    ["Revenue", "Tax", 8],
    ["Revenue", "Operational Costs", 40],

    ["Revenue", "Amazon Web Services (AWS)", 13],
  ];

  const options = {
    width: 700,
    tooltip: { trigger: "none" },
    sankey: {
      link: {
        // colorMode: "gradient",
        color: {
          fill: "#82345B",
          stroke: "black",
          strokeWidth: 10,
          fillOpacity: 0.2,
        },
      },
      node: {
        colors: [
          "#EF5FA7",
          "#EF5FA7",
          "#EF5FA7",
          "#EF5FA7",
          "#EF5FA7",
          "#EF5FA7",
          "#EF5FA7",
          "#EF5FA7",
          "#EF5FA7",
          "#EF5FA7",
          "#EF5FA7",
        ],

        label: {
          fontSize: 12,
          color: "transparent",
          bold: true,
          italic: false,
        },
        nodePadding: 50,
        labelPadding: 0,
        width: 20,
        interactivity: false,
      },
    },
  };

  const SankeyDescription = ({ title, description }) => {
    return (
      <div className="flex flex-col">
        <div className="font-bold">{title}</div>
        <div className="text">{description}</div>
      </div>
    );
  };

  return (
    <div className="flex flex-col w-full items-center justify-center gap-12">
      <div className="flex flex-row justify-center items-center w-full h-[400px]">
        <Chart
          chartType="Sankey"
          height="400px"
          // width="100px"
          data={data}
          options={options}
        />
      </div>
      <div className="flex flex-row w-full items-center justify-center gap-24">
        <div className="flex flex-col h-full w-full max-w-sm gap-6">
          <SankeyDescription
            title={"Advertisement"}
            description={
              "Users on the Emerald Version are served Raindrop Advertisements."
            }
          />
          <SankeyDescription
            title={"Users"}
            description={
              "Users on the Sapphire Version give 10% of their contribution for additional in-app features and removing restrictions."
            }
          />
          <SankeyDescription
            title={"Organisations"}
            description={
              "Organisations pay a tiered flat monthly fee depending on the number of users."
            }
          />
        </div>

        <div className="flex flex-col h-full w-full max-w-sm gap-6">
          <SankeyDescription
            title={"Stripe"}
            description={
              "We distribute payments through Stripe, charges £0.20 + 1.5% per transaction.  For a £40 contribution, £0.80 goes to Stripe, £3.20 to The Raindrop Company."
            }
          />
          <SankeyDescription
            title={"Operational Costs"}
            description={
              "The Raindrop Company will require an extensive staff of engineers, designers, lawyers."
            }
          />
          <SankeyDescription
            title={"Amazon Web Services (AWS)"}
            description={
              "Application software (EKS), databases (RDS), file storage (S3) will all be hosted on AWS."
            }
          />
        </div>
      </div>
    </div>
  );
};

const StratusHome = () => {
  return (
    <div
      id={"raindrop-website-global"}
      className={
        "flex flex-col items-center   overflow-x-clip justify-center w-full"
      }
    >
      <div
        id="raindrop-website-inner"
        className={
          "flex flex-col w-full gap-32 md:gap-40 max-w-5xl px-4 py-32 md:py-32 "
        }
      >
        <ContentHero />

        <ContentMission />
        <ContentProtect />
        <ContentPhone />

        <ContentSimplicity />

        {/* <ContentSeeTheDifference /> */}
        {/* <ContentShareTheLove /> */}
        {/* <ContentWaterfall /> */}
        {/* <ContentPricing /> */}
        {/* <ContentOrganisationPricing /> */}

        {/* <ContentEmployeeBenefits /> */}

        {/* <ContentQuote /> */}
        <ContentSocialMedia />

        {/* <ContentDemoVideo /> */}
        <ContentGetStarted />

        {/* <ContentFounder /> */}

        {/* <ContentAdvertisements /> */}
        {/* <ContentSankey /> */}
      </div>
    </div>
  );
};

export default StratusHome;
